import React from "react";

const Home = () => {
  return <div>Welcome to the okason</div>;
};

export default Home;
